var React = require('react');

function LinkedInIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m298.32 57h3.2v-9.2340426h-3.2zm1.6-10.4255319c-1.056 0-1.92-.8042553-1.92-1.7872341 0-.9829787.864-1.787234 1.92-1.787234s1.92.8042553 1.92 1.787234c0 .9829788-.864 1.7872341-1.92 1.7872341zm10.88 10.4255319v-5.8382979s-.352-1.2212766-1.6-1.1617021-1.664.2382979-2.24.8638298v6.1361702h-3.2v-9.2340426h3.2v1.3702128s1.056-1.906383 3.2-1.7574468c1.984.1191489 3.456 1.2510638 3.776 3.6638298h.064v5.9574468z","fill":"#002d58","fillRule":"evenodd","transform":"translate(-298 -43)"}));
}

LinkedInIcon.defaultProps = {"height":"14","viewBox":"0 0 16 14","width":"16"};

module.exports = LinkedInIcon;

LinkedInIcon.default = LinkedInIcon;
